<!-- <lib-site-setup-navbar
 [stepNumber]="StepNumberEnum.SoftwareLicenseVideo"
  class="w-full"
  [loggedInUser]="vm().currentUser"
></lib-site-setup-navbar> -->
<h1 class="mt-10 text-h1 font-semibold">{{ 'site_setup_contract_licensing_agreement' | translate }}</h1>
<h4 class="mt-2 text-h4 font-light">{{ 'site_setup_contract_licensing_agreement_subtitle' | translate }}</h4>

<div class="mt-10 max-w-[1000px]">
  <lib-onboarding-video
    [fileType]="licenseVideo.fileType || ''"
    [videoUrl]="licenseVideo.videoUrl || ''"
    [videoTitle]="licenseVideo.title || ''"
    [thumbnailUrl]="licenseVideo.thumbnailUrl || ''"
    [installationContractId]="vm().contract?.data?.id"
    tutorialModule="site_installation"
  ></lib-onboarding-video>

  <div class="my-10 flex justify-end text-text-primary">
    <div class="flex items-center gap-8">
      <button class="btn-primary-big" (click)="next()">{{ 'site_install_server_overview_next_button' | translate }}</button>
    </div>
  </div>
</div>
